;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('deskfyHeader', deskfyHeader)

  /* @ngInject */
  function deskfyHeader () {
    return {
      restrict: 'EA',
      scope: {
        hideSidebarMenu: '<',
        public: '<'
      },
      templateUrl: '/core/directives/deskfy-header/deskfy-header-directive.html?$$REVISION$$',
      controller: 'DeskfyHeaderController'
    }
  }
})()
